import request from '@/service'
import type { Result } from '@/service/http/types'

// --------------------------------------------------------------------------------
// 接口类型定义
// --------------------------------------------------------------------------------

/**
 * 配置查询参数
 */
export interface OnlineConfigGetParams {
  configType: string
}

/**
 * 配置信息
 */
export interface OnlineConfig {
  id?: string
  userId?: string
  filePath: string
  configContent: string
  configType: string
  name: string
  imgUrl?: string
  uploadTime?: string
}

// --------------------------------------------------------------------------------
// 接口请求方法
// --------------------------------------------------------------------------------

/**
 * 配置列表获取
 * @param params
 * @returns Promise<Result<OnlineConfig>>
 */
export const configGet = (
  params: OnlineConfigGetParams,
): Promise<Result<OnlineConfig[] | null>> => {
  return request.request<Result<OnlineConfig[] | null>>({
    url: '/apiDriver/v1/driver/config3/get',
    method: 'POST',
    data: params,
  })
}

/**
 * 配置保存
 */
export const configFileUpload = (file: File): Promise<Result<OnlineConfig>> => {
  const formData = new FormData()
  formData.append('file', file)

  return request.request<Result<OnlineConfig>>({
    url: '/apiDriver/v1/file/upload',
    method: 'POST',
    data: formData,
    timeout: 10000,
  })
}

/**
 * 配置保存
 */
export const configSave = (conf: OnlineConfig): Promise<Result<OnlineConfig | null>> => {
  return request.request<Result<OnlineConfig | null>>({
    url: '/apiDriver/v1/driver/config3/save',
    method: 'POST',
    data: conf,
  })
}

/**
 * 配置删除
 */
export const configDelete = (id: string): Promise<Result<OnlineConfig>> => {
  return request.request<Result<OnlineConfig>>({
    url: `/apiDriver/v1/driver/config3/delete/${id}`,
    method: 'GET',
  })
}

/**
 * 配置更新
 */
export const configUpdate = (conf: OnlineConfig): Promise<Result<OnlineConfig>> => {
  return request.request<Result<OnlineConfig>>({
    url: '/apiDriver/v1/driver/config3/update',
    method: 'POST',
    data: conf,
  })
}
